/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('faq-header')) {
  const FaqHeader = class extends HTMLElement {
    connectedCallback() {
      this.classNames = {
        questionContainerInactive: 'faq-search-item-inactive',
        sectionWithIndexStatus: 'section-faq-header--with-index'
      };

      this.searchInput = this.querySelector('.faq-search__input');
      if (this.searchInput) {
        this.searchInput.addEventListener('change', this.performSearch.bind(this));
        this.searchInput.addEventListener('keyup', this.performSearch.bind(this));
        this.searchInput.addEventListener('paste', this.performSearch.bind(this));
      }

      this.debouncedBuildIndex = debounce(this.buildIndex.bind(this), 50);
      document.addEventListener('theme:faq-header-update', this.debouncedBuildIndex);
      this.debouncedBuildIndex();

      if (this.querySelector('.faq-index')) {
        this.addEventListener('click', FaqHeader.handleIndexClick.bind(this));
        this.closest('.section-faq-header').classList.add(this.classNames.sectionWithIndexStatus);
        this.resizeIndex.call(this);
        this.debouncedResizeIndex = debounce(this.resizeIndex.bind(this), 250);
        window.addEventListener('resize', this.debouncedResizeIndex);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('theme:faq-header-update', this.debouncedBuildIndex);
      window.removeEventListener('resize', this.debouncedResizeIndex);
    }

    buildIndex() {
      const faqHeaderSection = this.closest('.section-faq-header');
      const indexContainer = this.querySelector('.faq-index__item-container');

      if (indexContainer) {
        indexContainer.querySelectorAll('.faq-index-item').forEach((el) => {
          el.parentNode.removeChild(el);
        });
      }

      this.linkedCollapsibleTabs = [];
      this.linkedQuestionContainers = [];
      this.linkedContent = [];

      let currentElement = faqHeaderSection;
      let i = 0;
      while (currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains('section-collapsible-tabs')) {
        currentElement = currentElement.nextElementSibling;

        // build list of searchable content
        this.linkedCollapsibleTabs.push(currentElement);
        currentElement.querySelectorAll('.collapsible-tabs__tab').forEach((el) => this.linkedQuestionContainers.push(el));
        currentElement.querySelectorAll('.collapsible-tabs__content').forEach((el) => this.linkedContent.push(el));

        // build index UI
        if (indexContainer) {
          const currentElementHeading = currentElement.querySelector('.collapsible-tabs__heading');
          if (currentElementHeading) {
            if(i>0){
            const html = `
              <div class="faq-index-item">
                <a class="faq-index-item__link"></a>
              </div>`;
            const htmlFragment = document.createRange().createContextualFragment(html);
            const link = htmlFragment.querySelector('.faq-index-item__link');
            //link.href = `#${currentElementHeading.id}`;
              link.classList.add(currentElementHeading.id);
               link.setAttribute('data-id', currentElementHeading.id);
            link.innerHTML = currentElementHeading.innerHTML;
            indexContainer.appendChild(htmlFragment);
            } else {
              const html = `
              <div class="faq-index-item">
                <a class="faq-index-item__link active"></a>
              </div>`;
            const htmlFragment = document.createRange().createContextualFragment(html);
            const link = htmlFragment.querySelector('.faq-index-item__link');
           // link.href = `#${currentElementHeading.id}`;
                link.classList.add(currentElementHeading.id);
              link.setAttribute('data-id', currentElementHeading.id);
            link.innerHTML = currentElementHeading.innerHTML;
            indexContainer.appendChild(htmlFragment);
            }
          }
          i++;
        }
      
      }

      if (indexContainer) {
        this.resizeIndex.call(this);
      }
    }

    resizeIndex() {
      const stickyContainer = this.querySelector('.faq-index__sticky-container');
      const faqHeaderSection = this.closest('.section-faq-header');

      let currentElement = faqHeaderSection;
      while (currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains('section-collapsible-tabs')) {
        currentElement = currentElement.nextElementSibling;
      }

      const stickyContainerRect = stickyContainer.getBoundingClientRect();
      const currentElementRect = currentElement.getBoundingClientRect();

      stickyContainer.style.height = `${currentElementRect.bottom - stickyContainerRect.top}px`;
    }

    performSearch() {
      // defer to avoid input lag
      setTimeout(() => {
        const splitValue = this.searchInput.value.split(' ');

        // sanitise terms
        const terms = [];
        splitValue.forEach((t) => {
          if (t.length > 0) {
            terms.push(t.toLowerCase());
          }
        });

        // search
        this.linkedQuestionContainers.forEach((el) => {
          if (terms.length) {
            let termFound = false;
            const matchContent = el.textContent.toLowerCase();
            terms.forEach((term) => {
              if (matchContent.indexOf(term) >= 0) {
                termFound = true;
              }
            });
            if (termFound) {
              el.classList.remove(this.classNames.questionContainerInactive);
            } else {
              el.classList.add(this.classNames.questionContainerInactive);
            }
          } else {
            el.classList.remove(this.classNames.questionContainerInactive);
          }
        });

        // hide non-question content if doing a search
        this.linkedContent.forEach((el) => {
          if (terms.length) {
            el.classList.add(this.classNames.questionContainerInactive);
          } else {
            el.classList.remove(this.classNames.questionContainerInactive);
          }
        });
      }, 10);
    }
    

    static handleIndexClick(evt) {
      if (evt.target.classList.contains('faq-index-item__link')) {
        evt.preventDefault();
        console.log(evt);
        document.querySelectorAll('.faq-index-item__link').forEach((title)=>{
          title.classList.remove("active");
          
        });
        evt.target.classList.add("active");

    const activeElement = document.querySelector('.faq-index-item__link.active');

        const dataId = activeElement.getAttribute('data-id');
        
   


const targetDiv1 = document.getElementById('faq-about-the-shoes');
 const targetDiv2 = document.getElementById('faq-fit-sizing');
 const targetDiv3 = document.getElementById('faq-shipping-delivery');
 const targetDiv4 = document.getElementById('faq-exchanges-returns');
 const targetDiv5 = document.getElementById('faq-gift-cards');
 const targetDiv6 = document.getElementById('faq-stores');
 const targetDiv7 = document.getElementById('faq-care');
 const targetDiv8 = document.getElementById('faq-contact-us');

if(dataId=='faq-about-the-shoes')
{
	targetDiv1.style.display = 'block';
	targetDiv2.style.display = 'none';
	targetDiv3.style.display = 'none';
	targetDiv4.style.display = 'none';
	targetDiv5.style.display = 'none';
	targetDiv6.style.display = 'none';
	targetDiv7.style.display = 'none';
	targetDiv8.style.display = 'none';
}
if(dataId=='faq-fit-sizing')
{
	targetDiv1.style.display = 'none';
	targetDiv2.style.display = 'block';
	targetDiv3.style.display = 'none';
	targetDiv4.style.display = 'none';
	targetDiv5.style.display = 'none';
	targetDiv6.style.display = 'none';
	targetDiv7.style.display = 'none';
	targetDiv8.style.display = 'none';
}
if(dataId=='faq-shipping-delivery')
{
	targetDiv1.style.display = 'none';
	targetDiv2.style.display = 'none';
	targetDiv3.style.display = 'block';
	targetDiv4.style.display = 'none';
	targetDiv5.style.display = 'none';
	targetDiv6.style.display = 'none';
	targetDiv7.style.display = 'none';
	targetDiv8.style.display = 'none';
}
if(dataId=='faq-exchanges-returns')
{
	targetDiv1.style.display = 'none';
	targetDiv2.style.display = 'none';
	targetDiv3.style.display = 'none';
	targetDiv4.style.display = 'block';
	targetDiv5.style.display = 'none';
	targetDiv6.style.display = 'none';
	targetDiv7.style.display = 'none';
	targetDiv8.style.display = 'none';
}
if(dataId=='faq-gift-cards')
{
	targetDiv1.style.display = 'none';
	targetDiv2.style.display = 'none';
	targetDiv3.style.display = 'none';
	targetDiv4.style.display = 'none';
	targetDiv5.style.display = 'block';
	targetDiv6.style.display = 'none';
	targetDiv7.style.display = 'none';
	targetDiv8.style.display = 'none';
}
if(dataId=='faq-stores')
{
	targetDiv1.style.display = 'none';
	targetDiv2.style.display = 'none';
	targetDiv3.style.display = 'none';
	targetDiv4.style.display = 'none';
	targetDiv5.style.display = 'none';
	targetDiv6.style.display = 'block';
	targetDiv7.style.display = 'none';
	targetDiv8.style.display = 'none';
}
if(dataId=='faq-care')
{
	targetDiv1.style.display = 'none';
	targetDiv2.style.display = 'none';
	targetDiv3.style.display = 'none';
	targetDiv4.style.display = 'none';
	targetDiv5.style.display = 'none';
	targetDiv6.style.display = 'none';
	targetDiv7.style.display = 'block';
	targetDiv8.style.display = 'none';
}
if(dataId=='faq-contact-us')
{
	targetDiv1.style.display = 'none';
	targetDiv2.style.display = 'none';
	targetDiv3.style.display = 'none';
	targetDiv4.style.display = 'none';
	targetDiv5.style.display = 'none';
	targetDiv6.style.display = 'none';
	targetDiv7.style.display = 'none';
	targetDiv8.style.display = 'block';
}
         



        
       // const id = evt.target.href.split('#')[1];
        //const scrollTarget = document.getElementById(id);
        
      //let scrollTargetY = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 50;

        // sticky header offset
        //const stickyHeight = getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height');
       
        //if (stickyHeight) {
          //scrollTargetY -= parseInt(stickyHeight, 10);
       // }
        // window.scrollTo({
        //   top: scrollTargetY,
        //   behavior: 'smooth'
        // });
      }
    }
  };

  window.customElements.define('faq-header', FaqHeader);
  
// var faqFitSizingElements = document.querySelectorAll('.this');
// faqFitSizingElements.forEach(function(element) {
//   element.addEventListener('click', function() {
//     var faqFitSizingSection = document.getElementById('faq-fit-sizing');
//     var faqAboutTheShoesSection = document.getElementById('faq-about-the-shoes');
    
//     // Show the faq-fit-sizing section and hide faq-about-the-shoes section
//     if (faqFitSizingSection) {
//       faqFitSizingSection.style.display = 'block';
//     }

//     if (faqAboutTheShoesSection) {
//       faqAboutTheShoesSection.style.display = 'none';
//     }

    
//   });
// });

  
}